(function () {
  'use strict';

  const PCF = window.PCFitments;
  if (!PCF) return;

  /* Script tag is emitted once per section render — init each root only once */
  document.querySelectorAll('.pc-af').forEach(root => {
    if (root.dataset.pcAfReady) return;
    root.dataset.pcAfReady = '1';
    initAllFitments(root);
  });

  function initAllFitments(root) {
    let T = {};
    try {
      T = JSON.parse(root.querySelector('.pc-af__config').textContent);
    } catch (_) { /* fall back to defaults below */ }
    const TEXT = {
      allMakes:    T.allMakes    || 'All Makes',
      makes:       T.makes       || 'Makes',
      models:      T.models      || 'Models',
      addToCart:   T.addToCart   || 'Add to Cart',
      added:       T.added       || 'Added',
      unavailable: T.unavailable || 'This unit is not available right now.',
      loadError:   T.loadError   || 'Could not load fitments. Please refresh the page.',
      noResults:   T.noResults   || 'No results for',
      backTo:      T.backTo      || 'Back to [name]',
      reset:       T.reset       || 'Start Over',
      outOfStock:  T.outOfStock  || 'Out of stock',
    };

    const SEARCH_LIMIT = 200;

    const el = {
      search:  root.querySelector('.pc-af__search'),
      crumbs:  root.querySelector('.pc-af__crumbs'),
      actions: root.querySelector('.pc-af__actions'),
      status:  root.querySelector('.pc-af__status'),
      loading: root.querySelector('.pc-af__loading'),
      view:    root.querySelector('.pc-af__view'),
      atc:     root.querySelector('.pc-af__atc'),
    };

    let data = null;

    /* ── Helpers ──────────────────────────────────────────────── */
    const same = (a, b) => String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();

    function node(tag, className, text) {
      const n = document.createElement(tag);
      if (className) n.className = className;
      if (text !== undefined) n.textContent = text; /* store data — always text, never HTML */
      return n;
    }

    function fitmentOf(makeObj, modelObj, variant) {
      return {
        make:   makeObj.make,
        model:  modelObj.model,
        body:   variant.body || '',
        engine: variant['engine-volume'] || '',
        socket: variant.socket || '',
      };
    }

    function showStatus(text, type) {
      el.status.textContent = text || '';
      el.status.className = type ? `pc-af__status is-${type}` : 'pc-af__status';
    }

    function setLoading(on) {
      el.loading.classList.toggle('is-visible', on);
    }

    /* ── URL state (?make=&model=&body=&engine=) ──────────────── */
    function readState() {
      const p = new URLSearchParams(window.location.search);
      return {
        make:   p.get('make')   || '',
        model:  p.get('model')  || '',
        body:   p.get('body')   || '',
        engine: p.get('engine') || '',
      };
    }

    function go(state) {
      window.history.pushState({}, '', PCF.pageUrl(window.location.pathname, state));
      el.search.value = '';
      render(state);
      if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    function findMake(name) {
      return data.find(m => same(m.make, name)) || null;
    }

    function findModel(makeObj, name) {
      return (makeObj && makeObj.models.find(md => same(md.model, name))) || null;
    }

    /* ── Rendering ────────────────────────────────────────────── */
    function renderCrumbs(parts) {
      el.crumbs.innerHTML = '';
      parts.forEach((part, i) => {
        const isLast = i === parts.length - 1;
        if (i) el.crumbs.appendChild(node('span', 'pc-af__crumb-sep', '›'));
        if (isLast) {
          const current = node('span', 'pc-af__crumb is-active', part.label);
          current.setAttribute('aria-current', 'page');
          el.crumbs.appendChild(current);
        } else {
          const btn = node('button', 'pc-af__crumb', part.label);
          btn.type = 'button';
          btn.addEventListener('click', () => go(part.state));
          el.crumbs.appendChild(btn);
        }
      });
    }

    /* Explicit Back / Start Over buttons — the breadcrumb alone is easy to miss.
       back: { label, onClick } or null; showReset: also offer a jump to All Makes */
    function renderActions(back, showReset) {
      el.actions.innerHTML = '';
      if (back) {
        const btn = node('button', 'pc-af__back');
        btn.type = 'button';
        btn.insertAdjacentHTML('beforeend', `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path d="M8.5 2.5L4 7l4.5 4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`);
        btn.appendChild(node('span', '', TEXT.backTo.replace('[name]', () => back.label)));
        btn.addEventListener('click', back.onClick);
        el.actions.appendChild(btn);
      }
      if (showReset) {
        const reset = node('button', 'pc-af__reset', TEXT.reset);
        reset.type = 'button';
        reset.addEventListener('click', () => go({}));
        el.actions.appendChild(reset);
      }
    }

    function heading(text) {
      return node('h2', 'pc-af__heading', text);
    }

    function tileGrid(items) {
      const grid = node('div', 'pc-af__grid');
      items.forEach(({ label, onClick }) => {
        const btn = node('button', 'pc-af__tile', label);
        btn.type = 'button';
        btn.addEventListener('click', onClick);
        grid.appendChild(btn);
      });
      return grid;
    }

    function render(state) {
      showStatus('');
      const makeObj  = state.make ? findMake(state.make) : null;
      const modelObj = makeObj && state.model ? findModel(makeObj, state.model) : null;

      if (modelObj)     renderVariants(makeObj, modelObj, state);
      else if (makeObj) renderModels(makeObj);
      else              renderMakes();
    }

    function renderMakes() {
      renderCrumbs([{ label: TEXT.allMakes }]);
      renderActions(null, false);
      el.view.innerHTML = '';
      el.view.appendChild(tileGrid(data.map(m => ({
        label: m.make,
        onClick: () => go({ make: m.make }),
      }))));
    }

    function renderModels(makeObj) {
      renderCrumbs([
        { label: TEXT.allMakes, state: {} },
        { label: makeObj.make },
      ]);
      renderActions({ label: TEXT.allMakes, onClick: () => go({}) }, false);
      el.view.innerHTML = '';
      el.view.appendChild(heading(makeObj.make));
      el.view.appendChild(tileGrid(makeObj.models.map(md => ({
        label: md.model,
        onClick: () => go({ make: makeObj.make, model: md.model }),
      }))));
    }

    function renderVariants(makeObj, modelObj, state) {
      renderCrumbs([
        { label: TEXT.allMakes, state: {} },
        { label: makeObj.make, state: { make: makeObj.make } },
        { label: modelObj.model },
      ]);
      renderActions({ label: makeObj.make, onClick: () => go({ make: makeObj.make }) }, true);
      el.view.innerHTML = '';
      el.view.appendChild(heading(`${makeObj.make} ${modelObj.model}`));

      const list = node('ul', 'pc-af__variants');
      let selectedRow = null;

      modelObj.variants.forEach((variant, i) => {
        const fit = fitmentOf(makeObj, modelObj, variant);
        const row = node('li', 'pc-af__variant');
        row.dataset.index = i;

        const info = node('div', 'pc-af__variant-info');
        info.appendChild(node('span', 'pc-af__variant-body', fit.body));
        if (fit.engine) info.appendChild(node('span', 'pc-af__variant-engine', fit.engine));

        /* Out of stock in this market (theme setting rule) → no add to cart */
        const oos = PCF.isOutOfStock(fit.socket);
        const btn = node('button', oos ? 'pc-af__add is-oos' : 'pc-af__add', oos ? TEXT.outOfStock : TEXT.addToCart);
        btn.type = 'button';
        if (oos) btn.disabled = true;
        else btn.addEventListener('click', () => addToCart(fit, btn));

        row.append(info, btn);
        list.appendChild(row);

        if (!selectedRow && state.body && same(fit.body, state.body) && (!state.engine || same(fit.engine, state.engine))) {
          selectedRow = row;
        }
      });

      el.view.appendChild(list);

      if (selectedRow) {
        selectedRow.classList.add('is-selected');
        selectedRow.scrollIntoView({ block: 'center' });
      }
    }

    function renderSearch(raw) {
      const q = raw.toLowerCase();
      const makes = data.filter(m => m.make.toLowerCase().includes(q));
      const models = [];
      data.forEach(m => m.models.forEach(md => {
        if (md.model.toLowerCase().includes(q) || `${m.make} ${md.model}`.toLowerCase().includes(q)) {
          models.push([m, md]);
        }
      }));

      el.view.innerHTML = '';
      showStatus('');

      if (!makes.length && !models.length) {
        el.view.appendChild(node('p', 'pc-af__empty', `${TEXT.noResults} "${raw}"`));
        return;
      }
      if (makes.length) {
        el.view.appendChild(node('h3', 'pc-af__subheading', TEXT.makes));
        el.view.appendChild(tileGrid(makes.map(m => ({
          label: m.make,
          onClick: () => go({ make: m.make }),
        }))));
      }
      if (models.length) {
        el.view.appendChild(node('h3', 'pc-af__subheading', TEXT.models));
        el.view.appendChild(tileGrid(models.slice(0, SEARCH_LIMIT).map(([m, md]) => ({
          label: `${m.make} ${md.model}`,
          onClick: () => go({ make: m.make, model: md.model }),
        }))));
      }
    }

    /* ── Add to cart ──────────────────────────────────────────── */
    /* socket → /products/pcXX.js → first variant id → hidden .atcBtnDrawer
       (the cart drawer adds it with the Selection property and opens) */
    async function addToCart(fit, btn) {
      if (btn.disabled || PCF.isOutOfStock(fit.socket)) return;
      btn.disabled = true;
      btn.classList.add('is-busy');
      showStatus('');

      let variantId;
      try {
        variantId = await PCF.variantIdForSocket(fit.socket);
      } catch (_) {
        btn.disabled = false;
        btn.classList.remove('is-busy');
        showStatus(TEXT.unavailable, 'error');
        return;
      }

      el.atc.dataset.atc = variantId;
      el.atc.dataset.selection = PCF.selectionLabel(fit);
      el.atc.click();

      btn.classList.remove('is-busy');
      btn.classList.add('is-added');
      btn.textContent = TEXT.added;
      setTimeout(() => {
        btn.disabled = false;
        btn.classList.remove('is-added');
        btn.textContent = TEXT.addToCart;
      }, 2000);
    }

    /* Home page hand-off: add the selected variant once, only if it matches the URL */
    function addPendingFromHomePage(state) {
      const pending = PCF.takePending();
      if (!pending || !same(pending.make, state.make) || !same(pending.model, state.model)) return;

      const makeObj  = findMake(state.make);
      const modelObj = findModel(makeObj, state.model);
      if (!modelObj) return;

      const index = modelObj.variants.findIndex(v => PCF.sameFitment(pending, fitmentOf(makeObj, modelObj, v)));
      if (index === -1) return;

      const btn = el.view.querySelector(`.pc-af__variant[data-index="${index}"] .pc-af__add`);
      if (btn) addToCart(fitmentOf(makeObj, modelObj, modelObj.variants[index]), btn);
    }

    /* Name of the view behind the search results — "Holden Captiva", "Holden" or "All Makes" */
    function viewLabel(state) {
      const makeObj  = state.make ? findMake(state.make) : null;
      const modelObj = makeObj && state.model ? findModel(makeObj, state.model) : null;
      if (modelObj) return `${makeObj.make} ${modelObj.model}`;
      if (makeObj)  return makeObj.make;
      return TEXT.allMakes;
    }

    function clearSearch() {
      el.search.value = '';
      render(readState());
    }

    /* ── Events ───────────────────────────────────────────────── */
    el.search.addEventListener('input', () => {
      if (!data) return;
      const raw = el.search.value.trim();
      if (raw) {
        renderCrumbs([{ label: TEXT.allMakes, state: {} }, { label: raw }]);
        renderActions({ label: viewLabel(readState()), onClick: clearSearch }, true);
        renderSearch(raw);
      } else {
        render(readState());
      }
    });

    window.addEventListener('popstate', () => {
      if (!data) return;
      el.search.value = '';
      render(readState());
    });

    /* ── Init ─────────────────────────────────────────────────── */
    setLoading(true);
    PCF.load(root.dataset.fitmentsUrl)
      .then(makes => {
        data = makes;
        setLoading(false);
        const state = readState();
        render(state);
        addPendingFromHomePage(state);
      })
      .catch(() => {
        setLoading(false);
        PCF.takePending(); /* drop the hand-off so it never fires on a later visit */
        showStatus(TEXT.loadError, 'error');
      });
  }
})();
